export interface SaveIconProps {
  className?: string;
}

export function SaveIcon({ className }: SaveIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.667 2.5C11.7782 2.50212 11.8881 2.52459 11.9912 2.56641C12.0905 2.60703 12.182 2.66625 12.2588 2.74121L17.2588 7.74121C17.336 7.81908 17.397 7.91214 17.4385 8.01367C17.4798 8.11501 17.5006 8.22357 17.5 8.33301V15C17.5 15.663 17.2364 16.2987 16.7676 16.7676C16.2987 17.2364 15.663 17.5 15 17.5H5C4.33696 17.5 3.70126 17.2364 3.23242 16.7676C2.76358 16.2987 2.5 15.663 2.5 15V5C2.5 4.33696 2.76358 3.70126 3.23242 3.23242C3.70126 2.76358 4.33696 2.5 5 2.5H11.667ZM5 4.16699C4.77899 4.16699 4.56741 4.25485 4.41113 4.41113C4.25485 4.56741 4.16699 4.77899 4.16699 5V15C4.16699 15.221 4.25485 15.4326 4.41113 15.5889C4.56741 15.7451 4.77899 15.833 5 15.833H5.83301V13.333C5.83309 12.6701 6.09667 12.0342 6.56543 11.5654C7.03419 11.0967 7.67008 10.8331 8.33301 10.833H11.667C12.3299 10.8331 12.9658 11.0967 13.4346 11.5654C13.9033 12.0342 14.1669 12.6701 14.167 13.333V15.833H15C15.221 15.833 15.4326 15.7451 15.5889 15.5889C15.7451 15.4326 15.833 15.221 15.833 15V8.6748L12.5 5.3418V6.66699C12.4999 6.88789 12.4121 7.09966 12.2559 7.25586C12.0997 7.41206 11.8879 7.49991 11.667 7.5H6.66699C6.44598 7.5 6.23343 7.41214 6.07715 7.25586C5.92105 7.09967 5.83309 6.88781 5.83301 6.66699V4.16699H5ZM8.33301 12.5C8.11211 12.5001 7.90034 12.5879 7.74414 12.7441C7.58794 12.9003 7.50009 13.1121 7.5 13.333V15.833H12.5V13.333C12.4999 13.1121 12.4121 12.9003 12.2559 12.7441C12.0997 12.5879 11.8879 12.5001 11.667 12.5H8.33301ZM7.5 4.16699V5.83301H10.833V4.16699H7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
